import React from "react"
import styled from "styled-components"
import AcUploader from "~/components/atoms/AcUploader"
import AcButton from "~/components/atoms/AcButton"
import AcIcon from "~/components/atoms/AcIcon"

interface Props {
  file: File
  onSuccess: (fileList: FileList) => void
  onDelete: () => void
}

export default function ContractUploader({ file, onSuccess, onDelete }: Props) {
  return (
    <Content>
      <Uploader isUploaded={file}>
        <AcUploader onSuccess={onSuccess} accept={".csv"}>
          {file ? (
            <p>CSVファイル登録済</p>
          ) : (
            <p>
              CSVファイルをこのエリアに
              <br />
              ドラッグ＆ドロップしてアップロード
            </p>
          )}

          <FileIcon>
            <AcButton disabled={Boolean(file)}>
              {file?.name || "クリックしてファイルを選択"}
            </AcButton>
            <AcIcon name={"file-lines"} />
          </FileIcon>
          <div className="note-overload">※下書き保存できる上限は500件です。</div>
        </AcUploader>
      </Uploader>
      {file && (
        <FileRemove>
          <AcIcon onClick={onDelete} name={"trash-can"} />
        </FileRemove>
      )}
    </Content>
  )
}

const Content = styled.div`
  width: 552px;
  position: relative;
  margin: 10px auto;
`

const Uploader = styled.div`
  background-color: ${(props) => (props.isUploaded ? `#ffffff` : `#F5F7FB`)};
  border: ${(props) => (!props.isUploaded ? `1px dashed #6B6BF8` : `2px solid #707070`)};
  display: flex;
  align-items: center;
  flex-direction: column;
  padding: 25px 0px 33px;
  margin-bottom: 10px;
  text-align: center;

  p {
    color: ${(props) => (props.isUploaded ? `#939393` : `#320ED7`)};
    font-size: 18px;
    font-weight: bold;
    text-align: center;
  }

  span {
    font-size: 13px;
    font-weight: normal;
    color: #222222;
  }

  .note-overload {
    text-align: center;
    color: #ff0000;
    font-size: 13px;
  }
`

const FileRemove = styled.div`
  text-align: right;
  color: #000000;
  > i {
    font-size: 27px;
    cursor: pointer;
    :hover {
      color: #320ed7;
    }
  }
`

const FileIcon = styled.div`
  position: relative;
  i {
    color: ${(props) => (props.isUploaded ? `#DEDEDE` : `#DEE3EC`)};
    font-size: 100px;
  }
  button,
  button.btn:hover {
    position: absolute;
    width: 360px;
    left: 50%;
    bottom: 0px;
    transform: translate(-50%, 0);
    background-color: #6b6bf9;
    &:disabled {
      background-color: #939393;
    }
  }
  margin-bottom: 20px;
`
